import { type FC, Fragment } from 'react';

interface Step {
  key: string;
  label: string;
  content: React.ReactNode;
  nextDisabled?: boolean;
}

interface ProposalProgressBarProps {
  steps: Step[];
  currentStepIndex: number;
}

export const ProposalProgressBar: FC<ProposalProgressBarProps> = ({ steps, currentStepIndex }) => {
  return (
    <div className="flex w-full justify-center bg-gray-50 py-8">
      <div className="mx-auto flex w-full max-w-3xl items-center justify-between px-4">
        {steps.map((s, idx) => {
          const isActive = idx === currentStepIndex;
          const isCompleted = idx < currentStepIndex;
          return (
            <Fragment key={s.key}>
              <div className="flex items-center">
                <div
                  className={`flex h-8 w-8 items-center justify-center rounded-full border-2 text-sm font-bold transition-colors
                    ${isActive ? 'border-[#ef4444] bg-white text-[#ef4444] ring-2 ring-[#ef4444]' : isCompleted ? 'border-[#ef4444] bg-[#fee2e2] text-[#ef4444]' : 'border-gray-300 bg-white text-gray-400'}`}
                >
                  {idx + 1}
                </div>
                <span
                  className={`ml-2 text-xs font-medium ${isActive ? 'font-bold text-[#ef4444]' : isCompleted ? 'text-[#ef4444]' : 'text-gray-500'}`}
                >
                  {s.label}
                </span>
              </div>
              {idx < steps.length - 1 && (
                <div className="mx-2 h-1 flex-1 rounded bg-gray-200">
                  <div
                    className={`h-1 rounded transition-all duration-300 ${idx < currentStepIndex ? 'w-full bg-[#ef4444]' : 'w-0 bg-gray-200'}`}
                    style={{ width: '100%' }}
                  />
                </div>
              )}
            </Fragment>
          );
        })}
      </div>
    </div>
  );
};
